import { Box, LinearProgress, Typography } from "@mui/material";
import FieldGrid from "../detail/FieldGrid";
import SideCard from "../detail/SideCard";
import { DetailOf } from "../detail/types";
import { TEXT } from "../detail/ui";
import { PRIMARY, dateOnly, hours, hoursVariance } from "../governanceStatus";

const Progress = ({ value }: { value: number }) => {
  const pct = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, maxWidth: 260 }}>
      <LinearProgress
        variant="determinate"
        value={pct}
        aria-label={`${pct}% complete`}
        sx={{
          flex: 1,
          height: 8,
          borderRadius: 4,
          backgroundColor: "#f0f0f3",
          "& .MuiLinearProgress-bar": { backgroundColor: PRIMARY, borderRadius: 4 },
        }}
      />
      <Typography component="span" variant="body2" sx={{ fontWeight: 700, color: TEXT, minWidth: 40 }}>
        {pct}%
      </Typography>
    </Box>
  );
};

/** Task fields, read-only. */
const TaskPanel = ({ item }: { item: DetailOf<"TASK"> }) => (
  <SideCard title="Task details">
    <FieldGrid
      fields={[
        { label: "Workstream", value: item.workstream },
        { label: "Start date", value: dateOnly(item.startDate) },
        { label: "Estimated hours", value: hours(item.estimatedMinutes) },
        { label: "Actual hours", value: hours(item.actualMinutes) },
        { label: "Hours variance", value: hoursVariance(item.actualMinutes, item.estimatedMinutes) },
        { label: "% complete", value: <Progress value={item.percentComplete} /> },
        { label: "Acceptance criteria", value: item.acceptanceCriteria, full: true },
      ]}
    />
  </SideCard>
);

export default TaskPanel;
